import React from 'react'

export default ({fill = 'currentColor', height, width, className}) => (
  <svg height={height} width={width} viewBox='0 0 100 100' className={className}>
    <path d="M70.24 65.76A5.98 5.98 0 0172 70c0 3.31-2.69 6-6 6-1.66 0-3.16-.67-4.24-1.76L44.18 56.66A23.83 23.83 0 0132.01 60c-13.25 0-24-10.75-24-24s10.75-24 24-24 24 10.75 24 24c0 4.45-1.23 8.6-3.34 12.17l17.57 17.59zM32 18c-9.94 0-18 8.06-18 18s8.06 18 18 18 18-8.06 18-18-8.06-18-18-18z" fill-rule="evenodd" clip-rule="evenodd"/>
  </svg>
)
